import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./Auth";
import Home from "./screens/Home";
import Activity from "./screens/Activity";
import Purchase from "./screens/Purchase";
import Account from "./screens/Account";
import LoginScreen from "./screens/Login";
import Success from "./screens/Success";
import Tutorials from "./screens/Tutorials";
import Academy from "./screens/Academy";
import AuthAction from "./screens/AuthAction";
function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/activity" element={<Activity />} />
          <Route path="/purchase" element={<Purchase />} />
          <Route path="/account" element={<Account />} />
          <Route path="/login" element={<LoginScreen />} />
          <Route
            path="/reset-password"
            element={<LoginScreen initialView="reset" />}
          />
          <Route path="/success" element={<Success />} />
          {/* Branded handler for Firebase Auth email links (reset / verify).
              Point each email template's "action URL" at /auth/action. */}
          <Route path="/auth/action" element={<AuthAction />} />
          <Route path="/tutorials" element={<Tutorials />} />
          <Route path="/academy" element={<Academy />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
